module.exports = __webpack_public_path__ + "img/full6-min.123a0311.png";